import { useEffect } from "react";
import moment from "moment";
import "moment/locale/es";

export const useScheduleInitialization = (
  fetchSchedules,
  fetchUsers,
  fetchClients
) => {
  useEffect(() => {
    const now = new Date();
    const month = moment(now).locale("en").format("MMMM");
    const year = moment(now).format("YYYY");

    console.log("data received", now);
    
    fetchSchedules({ month, year });
    fetchUsers();
    fetchClients();
  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
      });
    });

    return () => {
      resizeObserver.disconnect();
    };
  }, []);
};
